module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-03@2x.a0946567.png";